import { useRef, useCallback } from 'react';

const useSkeletonStore = () => {
  const store = useRef({
    default: []
  });
  const subscribers = useRef(new Set());
  const get = useCallback(() => store.current, []);
  const register = useCallback((group, value) => {
    if (!store.current[String(group)]) {
      store.current[String(group)] = [];
    }
    store.current[String(group)].push(value);
    store.current = structuredClone(store.current);
    subscribers.current.forEach(callback => callback());
  }, []);
  const unregister = useCallback((group, value) => {
    if (!store.current[String(group)]) {
      return;
    }
    store.current[String(group)] = store.current[String(group)].filter(item => item.id !== value);
    store.current = structuredClone(store.current);
    subscribers.current.forEach(callback => callback());
  }, []);
  const subscribe = useCallback(callback => {
    subscribers.current.add(callback);
    return () => subscribers.current.delete(callback);
  }, []);
  return {
    get,
    register,
    subscribe,
    unregister
  };
};

export { useSkeletonStore };
//# sourceMappingURL=useSkeletonStore.js.map
